export default string => string.replace(/-([a-z])/gi, (match, letter) => letter.toUpperCase());



// WEBPACK FOOTER //
// ./scripts/utilities/to-camel-case.js